<template>
    
    <div
        :class="this.class"
        :title="this.title"
        @click="onClick"
    >
        <div class="rq-button-inner">
            <font-awesome-icon
                v-if="this.icon.iconName"
                :icon="this.icon.iconName"
                class="rq-button-icon"
                :class="innerClass"
                :style="{ height: this.icon.style.height.toString() + 'px', width: this.icon.style.width.toString() + 'px' }"
            />
            <div
                v-show="this.showText"
                class="rq-button-text"
            >
                {{this.text}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomButton',
    props: {
        icon: {
            type: Object,
            required: true
        },
        /*
            iconName: string;       Should be font-awesome-icon component compliant
            style: {
                height: Number,
                width: Number,
            }
        */
        title: String,
        text: String,
        enabled: Boolean,
        showText: Boolean,
        innerClass: String,
    },
    emits: ['click'],
    computed: {
        class() {
            return ['rq-button',
                   { 'enabled': this.enabled }]
        }
    },
    methods: {
        onClick() {
            if (this.enabled){
                this.$emit('click');
            }
        },
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>